export enum UpsellType {
  GOAL = 'goal',
  UPGRADE = 'upgrade',
  ADDON = 'addon',
}
